.sliderContainer {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
